export const HIERACHY_LEVEL_MAP = {
  1: { code: 'LT00001266', name: 'Main' },
  2: { code: 'LT00001267', name: 'Goods Type' },
  3: { code: 'LT00000233', name: 'Division' },
  4: { code: 'LT00000717', name: 'Model' },
  5: { code: 'LT00001268', name: 'Basic Model' },
};

export const DEFAULT_MAX_QTY = Math.pow(2, 31) - 1;
export const DEFAULT_MAX_UNIT_PRICE = Math.pow(10, 12) - 1;

export const MOVEMENT_TYPES = [
  { code: 'GR', name: 'Goods Receive' },
  { code: 'WM', name: 'Goods Movement' },
  { code: 'GI', name: 'Goods Issue' },
  { code: 'RE', name: 'Goods Return' },
  { code: 'SC', name: 'Scrap' },
];

export const DESCENDING_TEXT = 'DESC';
export const ASCENDING_TEXT = 'ASC';